// Carer-parity S2 sub-decision 2 = 2a: pick the right fetch wrapper based
// on which BearerProvider is mounted above. Coordinator subtree (sessionStorage
// backend) gets apiFetch (no silent refresh — useAuth handles token rotation
// via /auth/refresh cookie). Carer subtree (localStorage backend) gets
// carerFetch (silent refresh on 401 via /auth/mobile-refresh + retry once
// before bouncing to /carer/login).
//
// Wizard auto-save retry chain (S3a-deliverable adoption): replaces direct
// apiFetch import with useFetcher() so a 401 mid-form does not lose the
// carer's autosave state.

import { useMemo } from "react";
import { apiFetch } from "../lib/api.js";
import { carerFetch } from "../lib/carerApi.js";
import { useBearer } from "./useBearer.js";

export type FetcherFn = <T>(path: string, init?: RequestInit) => Promise<T>;

export function useFetcher(): FetcherFn {
  const { backend } = useBearer();
  return useMemo<FetcherFn>(
    () => (backend === "localStorage" ? carerFetch : apiFetch),
    [backend],
  );
}
